import { render, staticRenderFns } from "./TaskDetailsTabbed.vue?vue&type=template&id=5fe5e1a6&scoped=true"
import script from "./TaskDetailsTabbed.vue?vue&type=script&lang=js"
export * from "./TaskDetailsTabbed.vue?vue&type=script&lang=js"
import style0 from "./TaskDetailsTabbed.vue?vue&type=style&index=0&id=5fe5e1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe5e1a6",
  null
  
)

export default component.exports